import React from 'react';
import { Col, Form } from 'react-bootstrap';
import { HubSettings } from 'dorian-shared/types/branch/HubOption';
import { HUB_HEADER_MAX_LENGTH, HUB_SUBHEADER_MAX_LENGTH } from './hubStepDefaults';

type HubSettingsFormProps = {
  settings?: HubSettings;
  onChange: (settings: HubSettings) => void;
  stepIndex?: number;
};

export function HubSettingsForm({ settings, onChange, stepIndex = 0 }: HubSettingsFormProps) {
  return (
    <Form.Row>
      <Form.Group as={Col} md={6} controlId={`hubHeaderText-${stepIndex}`} className="hub-settings-field">
        <Form.Label>
          Header Text
          <span className="text-muted">(optional)</span>
        </Form.Label>
        <Form.Control
          size="sm"
          value={settings?.header?.text ?? ''}
          onChange={(e) => onChange({ ...settings, header: { text: e.target.value }, subheader: settings?.subheader ?? null })}
          placeholder="e.g. Choose Your Slasher"
          maxLength={HUB_HEADER_MAX_LENGTH}
          className={(settings?.header?.text?.length ?? 0) > HUB_HEADER_MAX_LENGTH ? 'text-warn' : ''}
        />
        <Form.Text className="char-limit-info-box" style={{ top: '22px', bottom: 'auto' }}>
          {HUB_HEADER_MAX_LENGTH - (settings?.header?.text?.length ?? 0)}
        </Form.Text>
      </Form.Group>
      <Form.Group as={Col} md={6} controlId={`hubSubHeaderText-${stepIndex}`} className="hub-settings-field">
        <Form.Label>
          Subheader Text
          <span className="text-muted">(optional)</span>
        </Form.Label>
        <Form.Control
          size="sm"
          value={settings?.subheader?.text ?? ''}
          onChange={(e) => onChange({ ...settings, header: settings?.header ?? { text: '' }, subheader: { text: e.target.value } })}
          placeholder="e.g. Pick a character to date"
          maxLength={HUB_SUBHEADER_MAX_LENGTH}
          className={(settings?.subheader?.text?.length ?? 0) > HUB_SUBHEADER_MAX_LENGTH ? 'text-warn' : ''}
        />
        <Form.Text className="char-limit-info-box" style={{ top: '22px', bottom: 'auto' }}>
          {HUB_SUBHEADER_MAX_LENGTH - (settings?.subheader?.text?.length ?? 0)}
        </Form.Text>
      </Form.Group>
    </Form.Row>
  );
}
